import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, EmptyCollection, ExportMenu, FilterComponent, ImportMenu, PageLoader, Pagination, RevisionHistory, STableLoader, } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import { withRouter } from 'react-router';
import LgSubAssembliesList from "../components/LgSubAssembliesList";
import AddEditLgSubAssemblies from "../components/AddEditLgSubAssemblies";
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import LinkingPopup from "../../../shared_elements/LinkingPopup";
import NoAccess from "../../aircraftModels/components/NoAccess";

const LgSubAssembliesObj = {
	name: null,
	lg_position: null,
	remarks: null,
}

const LgSubAssembliesHeader = ({ isLgSubAssembly, deleted, handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
	return (
		<TableHead>
			<TableRow >
				{!isLgSubAssembly ? <TableCell >{checkPermission('config_data', 'lg_sub_assemblies', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> : !deleted ?
					<TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }}>{checkPermission('config_data', 'lg_sub_assemblies', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell> : null}
				<TableCell >
					{!isLgSubAssembly ? <TableSortLabel
						active={sortInfo.sort === 'name' ? true : false}
						direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('name')}
					>
						Name
					</TableSortLabel> : "Name"}
				</TableCell>
				<TableCell >
					{!isLgSubAssembly ? <TableSortLabel
						active={sortInfo.sort === 'position' ? true : false}
						direction={sortInfo.sort === 'position' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('position')}
					>
						Position
					</TableSortLabel> : "Position"}
				</TableCell>
				<TableCell >
					{!isLgSubAssembly ? <TableSortLabel
						active={sortInfo.sort === 'created_by' ? true : false}
						direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('created_by')}
					>
						Created By
					</TableSortLabel> : "Created By"}
				</TableCell>
				<TableCell >
					{!isLgSubAssembly ? <TableSortLabel
						active={sortInfo.sort === 'updated_by' ? true : false}
						direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('updated_by')}
					>
						Last Updated By
					</TableSortLabel> : "Last Updated By"}
				</TableCell>
				<TableCell >
					{!isLgSubAssembly ? <TableSortLabel
						active={sortInfo.sort === 'remarks' ? true : false}
						direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
						onClick={() => createSortHandler('remarks')}
					>
						Remarks
					</TableSortLabel> : "Remarks"}
				</TableCell>
			</TableRow>
		</TableHead>
	)
}

const LgSubAssemblies = ({ params, isLgSubAssembly, deleted, aircraftTypeName }) => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [isLoading, setLoading] = useState(false);
	const [filter, setFilter] = useState({});
	const [pageSelections, setPageSelections] = useState({});
	const [currentPage, setCurrentPage] = useState({});
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
	const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
	const [bulkUnlink, setBulkUnLink] = useState({ modal: false, data: null })
	const [addEditLgSubAssemblies, setAddEditLgSubAssemblies] = useState({ modal: false, data: null });
	const [deleteLgSubAssemblies, setDeleteLgSubAssemblies] = useState({ modal: false, data: null });
	const [unLinkLgSubAssemblies, setUnLinkLgSubAssemblies] = useState({ modal: false, data: null });
	const [revertLgSubAssemblies, setRevertLgSubAssemblies] = useState({ modal: false, data: null });
	const [lgSubAssembliesInfo, setLgSubAssembliesInfo] = useState({ list: [], pagination: {} });
	const [linkingLgSubAssembly, setLinkingLgSubAssembly] = useState({ modal: false, data: null })
	const [circularLoader, setCircularloader] = useState(false)
	const [pltConstants, setPltConstants] = useState([])


	useEffect(() => {
		getLgSubAssemblies({per_page:50}, !isLgSubAssembly ? "skeletonLoader" : 'pageLoader');
		trackActivity('Console Management', { page_title: !isLgSubAssembly ? 'Config Data : Lg Sub-Assemblies' : 'Config Data : Aircraft Types View page', event_type: !isLgSubAssembly ? 'Page Visited' : 'Lg Sub Assembly Tab Clicked' })
		getPltConstants()
	}, [])

	const getLgSubAssemblies = (query={}, loaderType) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
		const url = !isLgSubAssembly ? `config-data/lg-sub-assemblies/` : `config-data/aircraft-type/?linked_aircraft_types_name=lg_sub_assemblies&id=${params?.id}&action=link`;
		globalGetService(url, query)
			.then(response => {
				if (checkApiStatus(response)) {
					setLgSubAssembliesInfo(response?.data?.data)
					if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
			})
	}

	const toggleBulkOps = (item, checked, currentPage) => {
		setPageSelections(prevSelections => {
			const updatedSelections = { ...prevSelections };
			if (checked) {
				updatedSelections[currentPage] = updatedSelections[currentPage] || [];
				updatedSelections[currentPage].push(item?.id);
			} else {
				updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
			}
			return updatedSelections;
		});
	};

	const linkUnlink = (type, ids) => {
		const idss = !unLinkLgSubAssemblies.data ? Object.values(pageSelections).flat().filter(id => id) : [unLinkLgSubAssemblies?.data?.id]
		let payload;
		if (type === 'link') {
			payload = {
				aircraft_type_id: params.id || null,
				linked_aircraft_types: "lg_sub_assemblies" || null,
				ids: ids || [],
			};
		} else {
			payload = {
				aircraft_type_id: params.id || null,
				linked_aircraft_types: "lg_sub_assemblies" || null,
				ids: idss || [],
				action: 'unlink'
			};
		}

		const apiUrl = `config-data/aircraft-type/`;
		setCircularloader(true);
		globalPostService(apiUrl, payload)
			.then((response) => {
				if (checkApiStatus(response)) {
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					toggleModalFn();
					getLgSubAssemblies();
					setPageSelections({})
					trackActivity('Console Management', {
						event_desc: type === 'link' ? `Lg Sub Assemblies Linked Successfully` : 'Lg Sub Assemblies unLinked Successfully',
						page_title: 'Config Data : Aircraft Types View Page',
						event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
						updated_id: type === 'link' ? ids : idss || null,
						success_msg: response?.data?.message,
						data:JSON.stringify(payload)
					})
				} else {
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					getLgSubAssemblies();
					toggleModalFn();
					setPageSelections({})
					trackActivity('Console Management', {
						event_desc: type === 'link' ? 'Lg Sub Assemblies Linking Failed' : 'Lg Sub Assemblies Unlinking Failed',
						page_title: 'Config Data : Aircraft Types View Page',
						event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked',
						updated_id: type === 'link' ? ids : idss || null,
						error_msg: response?.data?.message,
						data:JSON.stringify(payload)
					})
				}
				setCircularloader(false);
			})
	}

	const onDelete = () => {
		setLoading(true);
		const ids = !deleteLgSubAssemblies.data ? Object.values(pageSelections).flat().filter(id => {
			const item = lgSubAssembliesInfo.list.find(item => item.id === id);
			return item && !item.deleted_at;
		}) : deleteLgSubAssemblies.data.id

		globalDeleteService(`config-data/lg-sub-assemblies/bulk-delete/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setDeleteLgSubAssemblies({ modal: false, data: null });
					getLgSubAssemblies({...filter, page: lgSubAssembliesInfo?.pagination?.page, per_page: lgSubAssembliesInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Lg Sub-Assemblies',
						event_type: `Item Deleted`,
						event_desc: 'Lg Sub-Assemblies Deleted Successfully',
						success_msg: response?.data?.message,
						deleted_id: ids
					});
				} else {
					setDeleteLgSubAssemblies({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Lg Sub-Assemblies',
						event_type: `Item Deleted`,
						event_desc: 'Lg Sub-Assemblies Deletion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const onRevert = () => {
		setLoading(true);
		const ids = !revertLgSubAssemblies.data ? Object.values(pageSelections).flat().filter(id => {
			const item = lgSubAssembliesInfo.list.find(item => item.id === id);
			return item && item.deleted_at;
		}) : revertLgSubAssemblies.data;

		globalPutService(`config-data/lg-sub-assemblies/restore/`, { ids })
			.then(response => {
				if (checkApiStatus(response)) {
					setRevertLgSubAssemblies({ modal: false, data: null });
					getLgSubAssemblies({...filter, page: lgSubAssembliesInfo?.pagination?.page, per_page: lgSubAssembliesInfo?.pagination?.per_page}, 'pageLoader');
					setCurrentPage({});
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Lg Sub-Assemblies',
						event_type: `Item Reverted`,
						event_desc: 'Lg Sub-Assemblies Reverted Successfully',
						success_msg: response?.data?.message,
						reverted_id: ids
					});
				} else {
					setRevertLgSubAssemblies({ modal: false, data: null });
					setLoading(false);
					setPageSelections({});
					setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					trackActivity('Console Management', {
						page_title: 'Config Data : Lg Sub-Assemblies',
						event_type: `Item Reverted`,
						event_desc: 'Lg Sub-Assemblies Reversion Failed',
						error_msg: response?.data?.message,
						item_id: ids
					});
				}
			});
	};

	const handleSelectAll = (event, currentPage) => {
		if (event?.target.checked) {
			const allIds = lgSubAssembliesInfo?.list.map(item => item.id);
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
		} else {
			setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
		}
	};

	const getFilteredSelectionCounts = () => {
		let deleteCount = 0;
		let revertCount = 0;

		if (pageSelections[currentPage]?.length) {
			pageSelections[currentPage].forEach(id => {
				const selectedItem = lgSubAssembliesInfo?.list?.find(item => item?.id === id);
				if (selectedItem) {
					if (selectedItem?.deleted_at) {
						revertCount++;
					} else {
						deleteCount++;
					}
				}
			});
		}
		return { deleteCount, revertCount };
	};

	const { deleteCount, revertCount } = getFilteredSelectionCounts();

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getLgSubAssemblies({ ...filter, ...sortQuery, page: 1, per_page: lgSubAssembliesInfo?.pagination?.per_page || 20 }, 'pageLoader');
	}

	const isSelectAllChecked = lgSubAssembliesInfo?.list?.length > 0 && pageSelections[currentPage]?.length === lgSubAssembliesInfo?.list?.length;

	const getConfirmColor = () => {
        if (revertLgSubAssemblies?.modal || bulkRevert?.modal) return "primary";
        if (deleteLgSubAssemblies?.modal || bulkDelete?.modal) return "secondary";
        if (unLinkLgSubAssemblies?.modal || bulkUnlink?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertLgSubAssemblies?.modal || bulkRevert?.modal) return "Revert";
        if (deleteLgSubAssemblies?.modal || bulkDelete?.modal) return "DELETE";
        if (unLinkLgSubAssemblies?.modal || bulkUnlink?.modal) return "UnLink";
        return "";
    };

    const getModal = () => {
        if (revertLgSubAssemblies?.modal) return revertLgSubAssemblies.modal;
        if (deleteLgSubAssemblies?.modal) return deleteLgSubAssemblies.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        if (unLinkLgSubAssemblies?.modal) return unLinkLgSubAssemblies.modal;
        if (bulkUnlink?.modal) return bulkUnlink.modal;
        return null;
    };

    const getTitle = () => {
        if (revertLgSubAssemblies?.modal) return "Revert Lg Sub Assemblies";
        if (deleteLgSubAssemblies?.modal) return "Delete Lg Sub Assemblies";
        if (bulkDelete?.modal) return `Delete Lg Sub Assemblies (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Lg Sub Assemblies (${revertCount})`;
        if (unLinkLgSubAssemblies?.modal) return "UnLink LG Sub Assembly";
        if (bulkUnlink?.modal) return `Unlink Lg Sub Assemblies (${deleteCount})`;
        return "";
    };

    const getContent = () => {
        if (revertLgSubAssemblies?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteLgSubAssemblies?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        if (unLinkLgSubAssemblies?.modal || bulkUnlink?.modal)
            return "Are you sure, you want to UnLink";
        return "";
    };

    const toggleModalFn = () => {
        if (revertLgSubAssemblies?.modal) {
            setRevertLgSubAssemblies({ modal: false, data: null });
        } else if (deleteLgSubAssemblies?.modal) {
            setDeleteLgSubAssemblies({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else if (bulkRevert?.modal) {
            setBulkRevert({ modal: false, data: null });
        } else if (bulkUnlink?.modal) {
            setBulkUnLink({ modal: false, data: null });
        } else if (unLinkLgSubAssemblies?.modal) {
            setUnLinkLgSubAssemblies({ modal: false, data: null });
        } else {
            setLinkingLgSubAssembly({ modal: false, data: null });
        }
    };


    const getDeleteRecordFn = () => {
        if (revertLgSubAssemblies?.modal || bulkRevert?.modal) return onRevert;
        if (deleteLgSubAssemblies?.modal || bulkDelete?.modal) return onDelete;
        if (unLinkLgSubAssemblies?.modal || bulkUnlink?.modal) return linkUnlink || null;
        return null;
    };
		const getPltConstants = () => {
			globalPostService('console/get-constants/', { constant_types: ['lg_position'] })
				.then(response => {
					if (checkApiStatus(response)) {
						setPltConstants(response.data.data)
					}
				})
		}

	const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
			'position': {
                'inputType': 'dropdown',
                'title': 'Position',
                'options': pltConstants?.filter(optionItem => optionItem?.type === 'lg_position'),
                'labelKey': 'label',
                'valueKey': 'label',
            },
		})

	return (
		<section className="asset-tech-specs" style={{ margin: isLgSubAssembly ? '0px' : '25px 0 0 75px' }}>
			{checkPermission('config_data', 'lg_sub_assemblies', 'R') ?
			<Paper elevation={isLgSubAssembly ? 0 : 1} className="tech-specs-card" style={{ height: isLgSubAssembly ? `${window.innerHeight - 490}px` : `${window.innerHeight - 90}px` }}>
				{!isLgSubAssembly ? <ConfigData /> : null}
				<div className="tech-specs-content" style={{ margin: isLgSubAssembly ? "8px 0px 0px 0px" : '', paddingTop: '0px' }}>
				{skeletonLoader ? <STableLoader count={6} size={9} /> :
					<div style={{ padding: isLgSubAssembly ? '0px' : '10px' }}>
						<Paper elevation={0} className="console-paper" style={{ padding: '4px 8px',marginBottom: "2px" }}>
							<Grid container spacing={1} alignItems="center">
									<Grid item md={6}>
											{!isLgSubAssembly ? <FilterComponent
												filter={filter}
												filterMenu={filterOption}
												getResponseBack={(applyFilter) => { getLgSubAssemblies({ ...applyFilter, page: 1, per_page: lgSubAssembliesInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
											/> : null}
									</Grid>
								<Grid item md={6}>
									{!isLgSubAssembly ? <ul className='list-inline flex-centered' style={{ float: 'right' }}>
										{revertCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Lg Sub-Assemblies', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Lg Sub-Assemblies` }) }} color="primary" size='small' variant="outlined">
													Revert ({revertCount})
												</Button>
											</li>
										)}
										{deleteCount > 0 && (
											<li className='list-inline-item'>
												<Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Lg Sub-Assemblies', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Lg Sub-Assemblies` }) }} color="secondary" size='small' variant="contained">
													Delete ({deleteCount})
												</Button>
											</li>
										)}
										{checkPermission('config_data', 'lg_sub_assemblies', 'C') &&<li className='list-inline-item'>
											<Button onClick={() => setAddEditLgSubAssemblies({ modal: true, data: LgSubAssembliesObj })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
										</li> }
										<li className='list-inline-item' style={{ cursor: 'pointer' }}>
											<RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdlgsubassemblies/`} queryParams={{ action: '0,1,2' }} />
										</li>

									</ul> : !deleted ?
										<ul style={{ textAlign: "right" }}>
											{deleteCount > 0 && checkPermission('config_data', 'lg_sub_assemblies', 'D') && (
												<li className='list-inline-item'>
													<Button onClick={() => { setBulkUnLink({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Lg Sub-Assemblies', item_type: 'Bulk Unlink', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Unlink Lg Sub Assemblies to Aircraft Type` }) }} color="secondary" size='small' variant="contained">
														Unlink ({deleteCount})
													</Button>
												</li>)}
												{checkPermission('config_data', 'lg_sub_assemblies', 'U') && <li className='list-inline-item'>
												<Button onClick={() => setLinkingLgSubAssembly({ modal: true, data: lgSubAssembliesInfo })} color="primary" size='small' variant="contained">Link LG Sub Assembly</Button>
											</li>}
											<li className='list-inline-item' style={{ cursor: 'pointer', verticalAlign: 'middle' }}>
												<RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdlgsubassemblies/`} queryParams={{ action: '0,1,2', linked_id: params?.id }} linkedName={aircraftTypeName} />
											</li>
										</ul> : null}
								</Grid>
							</Grid>
						</Paper>
						<Paper square>
						  <div style={{ height: isLgSubAssembly ? `${window.innerHeight - (lgSubAssembliesInfo?.list?.length ? 535 : 480)}px` : `${window.innerHeight - (lgSubAssembliesInfo?.list?.length ? 200 : 150)}px`, overflow: 'auto' }}>
							<Table className='mui-table-format' stickyHeader>
								<LgSubAssembliesHeader isLgSubAssembly={isLgSubAssembly} deleted={deleted} isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
									<TableBody>
										{lgSubAssembliesInfo?.list?.length > 0 && lgSubAssembliesInfo?.list?.map((item, index) =>
											<LgSubAssembliesList
                                                    linkedId={params?.id}
                                                    linkedName={aircraftTypeName}
												isLgSubAssembly={isLgSubAssembly}
												deleted={deleted}
												item={item}
												index={index}
												onDelete={setDeleteLgSubAssemblies}
												onRevert={setRevertLgSubAssemblies}
												unLink={setUnLinkLgSubAssemblies}
												onEditFn={() => setAddEditLgSubAssemblies({ modal: true, data: item, type: 'edit' })}
												onViewFn={() => setAddEditLgSubAssemblies({ modal: true, data: item, type: 'view' })}
												toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
												bulkIds={pageSelections[currentPage] || []}
											/>
										)}
									</TableBody>
							 </Table>
							  {!lgSubAssembliesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
							</div>
						</Paper>
						<Paper square>
							<Pagination
								pagination={lgSubAssembliesInfo?.pagination}
								onChangePage={(event, newPage) => { getLgSubAssemblies({ ...filter, page: newPage + 1, per_page: lgSubAssembliesInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
								onChangeRowsPerPage={(event) => getLgSubAssemblies({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
							/>
						</Paper>
					</div>}
				</div>
				{addEditLgSubAssemblies.modal ?
					<AddEditLgSubAssemblies
						addEditLgSubAssemblies={addEditLgSubAssemblies}
						lgSubAssembliesInfo={lgSubAssembliesInfo}
						toggleModalFn={() => setAddEditLgSubAssemblies({ modal: false, lgSubAssembliesData: [] })}
						getResponseBack={() => getLgSubAssemblies({...filter, page: lgSubAssembliesInfo?.pagination?.page, per_page: lgSubAssembliesInfo?.pagination?.per_page}, 'pageLoader')}
						modeType={addEditLgSubAssemblies?.type}
					/> : null
				}
				<DeletePopUp
					confirmColor={getConfirmColor()}
					confirmText={getConfirmText()}
					modal={getModal()}
					title={getTitle()}
					content={getContent()}
					toggleModalFn={toggleModalFn}
					deleteRecordFn={getDeleteRecordFn()}
					circularloader={circularLoader}
				/>
			</Paper> : <NoAccess />}
			{isLoading ? <PageLoader /> : null}
			{linkingLgSubAssembly.modal &&
				<LinkingPopup
					title="LG Sub Assembly"
					circularloader={circularLoader}
					linkUnlink={(type, ids) => linkUnlink(type, ids)}
					placeholder='Search By LG Sub Assembly ...'
					description='No Lg Sub Assemblies is available to link'
					url={`config-data/aircraft-type/?linked_aircraft_types_name=lg_sub_assemblies&id=${params?.id}&action=unlink`}
					data={lgSubAssembliesInfo}
					toggleModalFn={() => setLinkingLgSubAssembly({ modal: false, data: null })}
				/>
			}
		</section>
	)
}
export default withRouter(LgSubAssemblies);